import { render, staticRenderFns } from "./MobileBackgroundSelector.vue?vue&type=template&id=568017cb&scoped=true"
import script from "./MobileBackgroundSelector.vue?vue&type=script&lang=js"
export * from "./MobileBackgroundSelector.vue?vue&type=script&lang=js"
import style0 from "./MobileBackgroundSelector.vue?vue&type=style&index=0&id=568017cb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568017cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568017cb')) {
      api.createRecord('568017cb', component.options)
    } else {
      api.reload('568017cb', component.options)
    }
    module.hot.accept("./MobileBackgroundSelector.vue?vue&type=template&id=568017cb&scoped=true", function () {
      api.rerender('568017cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/MobileBackgroundSelector.vue"
export default component.exports